
import { Vue, Component, Watch } from 'vue-property-decorator';
import { form1, form2, form3, form4, form5 } from './config';
import {
  Icon,
  Picker,
  Popup,
  Button,
  Field,
  Toast,
  RadioGroup,
  Radio,
} from 'vant';
import Uploader from '../components/Uploader.vue';
import PptUpload from '../components/PptUpload.vue';
import { educationList, save } from '../api/wap';
import {} from 'vant';

Vue.use(Icon)
  .use(Picker)
  .use(Popup)
  .use(Button)
  .use(Field)
  .use(Toast)
  .use(Radio)
  .use(RadioGroup);
@Component({
  components: {
    Uploader,
    PptUpload,
  },
})
export default class Save extends Vue {
  form: any = [];
  columns: any = [];
  showPop: boolean = false;
  tipPop: boolean = false;
  formIdx: number = -1;
  type: number = 1;
  stTab: string[] = ['长图作品', '海报作品', 'H5作品'];
  stTabKey: number = 0;
  copyLink: string =
    process.env.VUE_APP_ENV_NAME === 'production'
      ? location.origin + '/shangyou_activity/2026h1/cqcc/signup/audio'
      : location.origin + '/2026h1/cqcc/signup/audio';
  async mounted() {
    if (!window.udid) {
      return this.$router.push('home');
    }

    if (!window.token) {
      window.openApp('mUserLogin');
      return;
    }
    const res: any = await educationList();
    this.columns = res.data;
    this.type = Number(this.$route.query.type);
    switch (Number(this.$route.query.type)) {
      case 1:
        this.form = form1;
        break;
      case 2:
        this.form = form2;
        break;
      case 3:
        this.form = form3;
        break;
      case 4:
        this.form = form4;
        break;
      case 5:
        this.form = form5;
        break;
    }
  }
  async uploadImg(index: number, key: string) {
    const uploaderRef = this.$refs[key] as Uploader;
    const uploader = Array.isArray(uploaderRef) ? uploaderRef[0] : uploaderRef;
    if (uploader) {
      const arr = await uploader.uploadToOss();
      this.form[index].value = arr;
    } else {
      console.warn('Uploader 组件未找到');
    }
  }
  async uploadImgTwo(index: number, key: string, idx: number) {
    const uploaderRef = this.$refs[key] as Uploader;
    const uploader = Array.isArray(uploaderRef)
      ? uploaderRef[idx]
      : uploaderRef;
    if (uploader) {
      try {
        const arr = await uploader.uploadToOss();
        // 只更新对应索引的 img 字段，保留 text 字段
        if (arr && arr.length > 0) {
          // 使用 Vue.set 或直接赋值确保响应式更新
          this.$set(this.form[index].value, idx, {
            ...this.form[index].value[idx],
            imageUrl: arr[0], // 只取第一个图片 URL
          });
        }
      } catch (error) {
        console.error('上传失败:', error);
        Toast.fail('图片上传失败，请重试');
      }
    } else {
      console.warn('Uploader 组件未找到');
    }
  }
  openPop(arr: any, index: number) {
    this.formIdx = index;
    this.showPop = true;
  }
  onConfirm(value: any) {
    this.form[this.formIdx].value = value;
    this.showPop = false;
  }

  onCancel() {
    this.showPop = false;
  }
  changeStTab(index: number) {
    this.stTabKey = index;
    if (index) {
      this.tipPop = true;
    }
  }
  onUploadSuccess(files: any[]) {
    console.log('上传成功:', files);
  }

  onFileUploaded(file: any) {
    console.log('单个文件上传成功:', file);
    this.form[file.index].value = [file.url];
  }

  onFileRemoved(file: any) {
    this.form[file.index].value = undefined;
    console.log('文件已删除:', file);
  }
  addExp(index: number, idx: number) {
    this.form[index].value.push({
      imageUrl: '',
      description: undefined,
    });
  }
  delExp(index: number, idx: number) {
    this.form[index].value.splice(idx, 1);
  }

  remove(index: number, idx: number) {
    if (this.form[index].value.length > idx) {
      this.form[index].value.splice(idx, 1);
    }
  }

  changeRadio(e: any) {
    if (e) {
      this.type = Number(this.$route.query.type);
      switch (Number(this.$route.query.type)) {
        case 1:
          this.form = form1;
          break;
        case 2:
          this.form = form2;
          break;
        case 3:
          this.form = form3;
          break;
        case 4:
          this.form = form4;
          break;
      }
    } else {
      this.type = Number(this.$route.query.type);
      switch (Number(this.$route.query.type)) {
        case 1:
          this.form = form1.slice(0, form1.length - 4);
          break;
        case 2:
          this.form = form2.slice(0, form1.length - 4);
          break;
        case 3:
          this.form = form3.slice(0, form1.length - 4);
          break;
        case 4:
          this.form = form4.slice(0, form1.length - 4);
          break;
      }
    }
  }

  async submit() {
    if (!window.token) {
      window.openApp('mUserLogin');
      return;
    }
    for (let i = 0; i < this.form.length; i++) {
      const item = this.form[i];
      // 跳过非必填项
      if (!item.require) {
        continue;
      }
      // 验证是否为空
      const value = item.value;

      if (item.type === 'imageInput') {
        // 检查图片数组是否为空或所有图片都没有实际文件
        const hasValidImage =
          Array.isArray(value) &&
          value.find((img) => {
            return img.imageUrl === '' || !img.imageUrl;
          });

        if (hasValidImage) {
          Toast.fail(`请上传${item.label}`);
          return false;
        }
        const hasValidText =
          Array.isArray(value) &&
          value.every(
            (val) => val && val.description && val.description.trim() !== '',
          );

        if (!hasValidText) {
          Toast.fail(`请填写作品说明`);
          return false;
        }
        continue; // 验证通过后继续下一个
      }
      const isEmpty =
        value === undefined ||
        value === null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        Toast.fail(
          `请${item.type === 'Select' ? '选择' : '填写'}${item.label}`,
        );
        return false;
      }

      // 针对 InputText 类型，验证字数是否达到最小要求（如果需要）
      if (item.type === 'InputText' && item.min) {
        if (value.length < item.min) {
          Toast.fail(`${item.label}至少需要${item.min}个字`);
          return false;
        }
      }
    }

    // 2. 所有验证通过，构建提交数据
    const submitData: any = {};
    this.form.forEach((item: any) => {
      submitData[item.key] = item.value;
    });
    submitData.workType = this.type;
    if (this.type === 2) {
      submitData.audioType = 1;
    }
    submitData.files = JSON.stringify(submitData.files);

    if (
      submitData.explanation &&
      submitData.explanation.length &&
      submitData.explanation.length === 1
    ) {
      submitData.explanation = submitData.explanation[0];
    } else {
      submitData.explanation = JSON.stringify(submitData.explanation);
    }
    if (submitData.cover && submitData.cover.length) {
      submitData.cover = submitData.cover[0];
    }

    const reb: any = await save(submitData);

    if (reb.code === 200) {
      setTimeout(() => {
        location.reload();
      }, 1500);
      Toast.success('提交成功');
    } else {
      Toast.fail(reb.msg);
    }
    // 3. 显示提交成功提示
    // Toast.success('提交成功');
  }
  copy() {
    this.$toast.success('复制成功');
  }
}
